module.exports = __webpack_public_path__ + "img/6683d8f.png";